"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var material_1 = require("@mui/material");
var PageHeader = __importStar(require("./O_PageHeader"));
var icons_1 = require("./icons");
var x_data_grid_1 = require("@mui/x-data-grid");
var Component = function (props) {
    return (Preact.h(Box_1.default, { sx: {
            paddingX: '26px',
            paddingTop: '32px',
            width: '100%',
        } },
        Preact.h(PageHeader.Component, { header: "".concat(props.tenant, " Products"), firstActionText: "Batch upload models", firstActionIcon: Preact.h(icons_1.AddIcon, null), secondActionText: "Upload CSV", secondActionIcon: Preact.h(icons_1.UploadIcon, null), secondAction: props.onCsvClick }),
        Preact.h(Box_1.default, { sx: {
                width: '100%',
                paddingBottom: '30px',
            } },
            Preact.h(x_data_grid_1.DataGrid, { rows: props.rows, columns: props.columns, onRowClick: function (product) {
                    props.onRowClick(product.row.productId);
                }, autoHeight: true, 
                // TODO: only hardcoded hex values seem to work for now but should be changed
                sx: {
                    backgroundColor: 'background.default',
                    '& div.MuiDataGrid-virtualScroller': {
                        overflow: 'auto !important',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: (0, material_1.alpha)('#FB3569', 0.08),
                    },
                    '& .MuiDataGrid-cell:hover': {
                        outline: '1px solid',
                        outlineColor: '#FB3569',
                    },
                } }))));
};
exports.Component = Component;
